<div class="forms-container" *ngIf="tangillaFormsService.formJsonLoaded">
  <div *ngIf="this.surveyService.isPreview" class="preview-message"
       [ngStyle]="{ 'background-color': tangillaFormsConfigService.getPreviewBackgroundColor()}">----------|
    Preview Mode ({{ this.surveyService.previewVersion === '1' ? 'with' : 'no' }} validation) | <a
      [href]="previewSwitchUrl"
      style="color:#fff;text-decoration:underline;font-size:11px;">switch</a>
    | <a [href]="liveLinkUrl" style="color:#fff;text-decoration:underline;font-size:11px;">live
      link</a> ----------
  </div>
  <div class="forms-wrapper">
    <div class="forms-content">
      <mat-toolbar class="py-4">
        <mat-toolbar-row class="tg-toolbar-row">
          <img class="my-3 association-logo" [src]="tangillaFormsConfigService.getLogo()"/>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="row header-bottom-border-row">
        <div class="col-3 header-bottom-border-line border-primary"></div>
        <div class="col-3 header-bottom-border-line border-quaternary"></div>
        <div class="col-3 header-bottom-border-line border-secondary"></div>
        <div class="col-3 header-bottom-border-line border-tertiary"></div>
      </div>
      <router-outlet></router-outlet>
      <div class="row footer-top-border-row">
        <div class="col-12 footer-top-border-line border-dark-grey"></div>
      </div>
    </div>
  </div>

  <div class="tangilla-forms-footer">
    <p class="text-center mt-5 mb-1" *ngIf="tangillaFormsConfigService.tangillaFormsConfig.title">{{ tangillaFormsConfigService.tangillaFormsConfig.title }}</p>
    <div class="social-media-links-wrapper pb-3">
      <ng-container *ngFor="let socialMediaLink of tangillaFormsConfigService.tangillaFormsConfig.social_media_links">
        <a href="{{socialMediaLink.url}}" class="social-media-link me-2" target="_blank">
          <i class="fa-brands {{socialMediaLink.icon}}"></i>
        </a>
      </ng-container>
    </div>
  </div>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
